import { Link, useParams } from 'react-router-dom';
import { productsData } from './Products';

function ProductDetails() {
  const { category, id } = useParams();
  const product = productsData[category]?.find((p) => p.id === parseInt(id));

  if (!product) return <div className="p-6">Product not found</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
      {/* Sidebar */}
      <aside >
        <Link
          to="/products"
          className="inline-block mb-4 px-4 py-2 bg-secondary text-white rounded-lg"
        >
          ← Back to Products
        </Link>
      </aside>

      {/* Product Details */}
      <div className="md:col-span-3">
        <h1 className="text-3xl font-bold text-gray-800 mb-10">{product.name}</h1>
        <img src={product.image} alt={product.name} loading="lazy" className="w-1/2 h-72 object-cover rounded-none mb-6" /> 
        <p className="text-gray-600 mb-6">{product.description}</p>
      </div>
    </div>
  );
}

export default ProductDetails;
